import { Box, Divider, Paper, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useStyles } from "./CompanyActivity.styles";
import { useStore } from "src/Shared/Hooks";
import { useParams } from "react-router-dom";
import { IRouteParams } from "../../Interfaces";
import moment from "moment";

const CompanyActivity = () => {
  const classes = useStyles();

  const {
    rootStore: {
      companyStore: {
        activities,
        getCompanyActitvity,
        activityPagination,
        activitiesLoading,
      },
    },
  } = useStore();

  const { companyRowID } = useParams<Partial<IRouteParams>>();

  useEffect(() => {
    getCompanyActitvity(companyRowID);
  }, [companyRowID]);

  const handleLoadMore = () => {
    getCompanyActitvity(companyRowID, true);
  };

  const formatActivityDate = (date: string | Date) => {
    if (!date) return "";
    return moment.utc(date).local().format("DD/MM/YYYY hh:mm A");
  };

  const localizeMessage = (msg: string) => {
    if (!msg) return "";
    return msg.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g, (match) => {
      return moment.utc(match).local().format("DD/MM/YYYY hh:mm A");
    });
  };

  return (
    <>
      <Box className={classes.root}>
        <Typography className={classes.title} variant="h5">
          Activity
        </Typography>
      </Box>

      <Paper elevation={0} className={classes.container}>
        {activities &&
          activities.length > 0 &&
          activities.map((activity, index) => (
            <Box key={index} className={classes.activityRow}>
              {/* Header */}
              <Box className={classes.headerRow}>
                <Typography className={classes.userName}>
                  {activity.userName}
                </Typography>

                <Typography className={classes.dateText}>
                  {activity.modifiedOn}
                </Typography>
              </Box>

              {/* Messages */}
              {activity.messages.map((msg, i) => (
                <Typography key={i} className={classes.messageText}>
                  {localizeMessage(msg)}
                </Typography>
              ))}

              {/* Divider */}
              {index !== activities.length - 1 && (
                <Divider className={classes.divider} />
              )}
            </Box>
          ))}

        {activityPagination.hasMore && (
          <Box sx={{ p: 2, textAlign: "center" }}>
            <Typography
              component="a"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (!activitiesLoading) handleLoadMore();
              }}
              sx={{
                cursor: activitiesLoading ? "default" : "pointer",
                color: activitiesLoading ? "text.disabled" : "primary.main",
                textDecoration: "none",
                fontWeight: "bold",
                "&:hover": {
                  textDecoration: activitiesLoading ? "none" : "underline",
                },
              }}
            >
              {activitiesLoading ? "Loading..." : "Load More"}
            </Typography>
          </Box>
        )}
      </Paper>
    </>
  );
};

export default observer(CompanyActivity);
